// Assets 
import Slider from "rc-slider"; 
import { 
  MdOutlineWbSunny, 
} from "react-icons/md"; 
 
import Card from "../CardHorizon";
import "rc-slider/assets/index.css";

const Phone = () => { 

  return ( 
        <div className="flex w-[300px] items-center justify-center "> 
<div className="w-[300px]">
        <div className="mt-3 w-full px-3">
          <Slider
            range
            count={1}
            defaultValue={[0, 20]}
            trackStyle={{
              backgroundColor: "rgb(67 24 255)",
              height: 10,
              cursor: "pointer",
            }}
            dot={{
              color: "red",
            }}
            handleStyle={{
              border: "3px solid white",
              backgroundColor: "rgb(67, 24, 255)",
              opacity: 1,
              height: 18,
              cursor: "pointer",
              width: 18,
            }}
            railStyle={{
              backgroundColor: "#E1E9F8",
              height: 10,
              cursor: "pointer",
            }}
          />
        </div>
</div>
        </div> 
  );
};

export default Phone;
